import { render, staticRenderFns } from "./ModalStudentCoinHistory.vue?vue&type=template&id=651765ab&scoped=true&lang=pug&"
import script from "./ModalStudentCoinHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentCoinHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651765ab",
  null
  
)

export default component.exports